<template>
  <div class="vote" ref="topBanner" id="vote">
    <div class="fixed">
      <div class="top_header top_sm">
        <div class="top_normal">
          <!-- <van-icon name="arrow-left" @click="returnGo"/> -->
          <img
            src="@/assets/img/back_.png"
            alt=""
            class="back_"
            @click="returnGo"
          />
        </div>
      </div>
    </div>
    <div class="titleBlock">
      <div class="mian_img">
        <img src="@/assets/img/vote/vote.jpg" alt="" />
      </div>
      <div class="title1">
        <p style="width: 0; height: 0; padding: 0"></p>
        <p @click="jump('#huodong')">活动介绍</p>
      </div>
      <!-- <div class="t_flex">
        <div>
          <p>大众评选</p>
        </div>
        <div>
          <p>业主评选</p>
        </div>
        <div>
          <p>专家评选</p>
        </div>
        <div>
          <p>评选公示</p>
        </div>
      </div> -->
    </div>
    <!-- <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/01.jpg" alt="" />
      </div>
      <div>
        <div style="width: 100%">
          <img src="@/assets/img/vote/vote.jpg" alt="" style="width: 100%" />
        </div>
      </div>
    </div> -->
    <div class="modular" style="margin-top: 0.5rem">
      <!-- <div class="title">
        <img src="@/assets/img/vote/02.jpg" alt="" />
      </div> -->
      <div class="v_width">
        <van-swipe class="my-swipe" indicator-color="white">
          <van-swipe-item>
            <video
              controls="controls"
              autoplay="true"
              loop
              src="https://www.xzhouse.com.cn/house/xzh_static/sVideo/voteVideo.mp4"
              style="width: 100%"
            >
              <!-- <source
                src="https://www.xzhouse.com.cn/house/xzh_static/sVideo/voteVideo.mp4"
              /> -->
            </video>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="v_title">守望来者·谋远前行 粉丝专享福利</div>
    </div>
    <!-- <div class="modular" style="margin-top: 0.3rem">
      <div>
        <van-swipe class="my-swipe" indicator-color="white">
          <van-swipe-item>
            <video
              controls
              src="https://www.xzhouse.com.cn/house/xzh_static/sVideo/运河小镇-全年红.mp4"
              poster="https://www.xzhouse.com.cn/house/xzh_static/sVideo/3e2d1c8ae44641288cf40e6a9a7f1060.jpg"
              style="width: 100%"
            >
              <source
                src="https://www.xzhouse.com.cn/house/xzh_static/sVideo/运河小镇-全年红.mp4"
              />
            </video>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="v_title">居者有其屋+居者优其屋</div>
    </div> -->
    <div style='text-align:center;color:red;font-size:0.3rem;margin-top:0.5rem'>首页排名按照投票数据进行实时变更</div>
    <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/1.jpg" alt="" />
      </div>
      <!-- <div class="t_word"></div> -->
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['2']"
            :key="item.id"
          >
            <div class="line_img" v-show="index==0">
              <img :src="img1" alt="">
            </div>
            <div class="line_img" v-show="index==1">
              <img :src="img2" alt="">
            </div>
            <div class="line_img" v-show="index==2">
              <img :src="img3" alt="">
            </div>
            <!-- <div class="line_img" v-show="index==3">
              <img :src="img4" alt="">
            </div> -->
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
                <!-- <i class="flash-across"></i> -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/2.jpg" alt="" />
      </div>
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['3']"
            :key="item.id"
          >
           <div class="line_img" v-show="index==0">
              <img :src="img1" alt="">
            </div>
            <div class="line_img" v-show="index==1">
              <img :src="img2" alt="">
            </div>
            <div class="line_img" v-show="index==2">
              <img :src="img3" alt="">
            </div>
            <!-- <div class="line_img" v-show="index==3">
              <img :src="img4" alt="">
            </div> -->
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
                <!-- <i class="flash-across"></i> -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/3.jpg" alt="" />
      </div>
      <!-- <div class="t_word">入选名单</div> -->
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['4']"
            :key="item.id"
          >
           <div class="line_img" v-show="index==0">
              <img :src="img1" alt="">
            </div>
            <div class="line_img" v-show="index==1">
              <img :src="img2" alt="">
            </div>
            <div class="line_img" v-show="index==2">
              <img :src="img3" alt="">
            </div>
            <!-- <div class="line_img" v-show="index==3">
              <img :src="img4" alt="">
            </div> -->
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
                <!-- <i class="flash-across"></i> -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/4.jpg" alt="" />
      </div>
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['5']"
            :key="item.id"
          >
           <div class="line_img" v-show="index==0">
              <img :src="img1" alt="">
            </div>
            <div class="line_img" v-show="index==1">
              <img :src="img2" alt="">
            </div>
            <div class="line_img" v-show="index==2">
              <img :src="img3" alt="">
            </div>
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/5.jpg" alt="" />
      </div>
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['6']"
            :key="item.id"
          >
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/6.jpg" alt="" />
      </div>
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['7']"
            :key="item.id"
          >
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/7.jpg" alt="" />
      </div>
      <div>
        <div class="v_flex">
          <div
            class="line"
            v-for="(item, index) in objData['8']"
            :key="item.id"
          >
            <div class="photo">
              <img :src="imgPath + 'sImgOther/' + item.imgId + '.jpg'" alt="" />
            </div>
            <div class="name">{{ item.title }}</div>
            <div class="btn">
              <p @click="btnJump(item.type)" class="flash-across">
                投票
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="modular">
      <div class="title">
        <img src="@/assets/img/vote/03.jpg" alt="" />
      </div>
      <div>
        <img src="" alt="" />
      </div>
      <div class="h_flex">
        <div>
          <p>2021年▶</p>
          <p>12月20日</p>
          <p class="h_word">网络投票启动</p>
        </div>
        <div>
          <p>2021年▶</p>
          <p>12月31日</p>
          <p class="h_word">网络投票结束</p>
        </div>
        <div>
          <p>2022年▶</p>
          <p>元月1-3日</p>
          <p class="h_word">粉丝福利领取</p>
        </div>
        <div>
          <p>2022年▶</p>
          <p>元月4日</p>
          <div class="h_word">
            <p>票选结果公示</p>
            <p>年度排行榜公示</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modular" id="huodong">
      <div class="title">
        <img src="@/assets/img/vote/04.jpg" alt="" />
      </div>
      <div class="hd_word">
        <div class="hd_bj">
          <p>（1）活动时间：</p>
          <p>2021-12-20 至 2021-12-31;</p>
        </div>
        <div class="hd_bj">
          <p>（2）投票须知：</p>
          <p>
            为保证票选结果的真实性，本次活动采用实名制投票评选，每个用户每日可投10票;
          </p>
        </div>
        <div class="hd_bj">
          <p>（3）主办单位：</p>
          <p>徐州市房地产信息网;</p>
        </div>
        <div class="hd_bj">
          <p>（4）活动福利：</p>
          <p>徐州市房地产信息网&升辉装饰城！</p>
        </div>
        <div class="hd_bj">
          <p>（5）领取时间：</p>
          <p>2022-1-1 至 2022-1-3</p>
        </div>
        <p style="text-align: center; padding: 0.1rem 0; margin-top: 0.5rem">
          专属福利购
        </p>
        <p style="text-indent: 0.3rem; color: #fff; line-height: 0.6rem">
          凡参与2021年守望来者·谋远前行榜单发布盛典暨中国·徐州房地产行业年度颁奖盛典网络投票活动的网友，投票相关信息（如投票验证手机号码）将于投票截止后递交至礼品提供方，参与用户均可凭借参与票选的手机号码到升辉装饰城7号厅5层客服中心签到并领取VIP认证卡。
        </p>
        <p style="text-align: center; padding: 0.1rem 0">
          持VIP认证卡客户均可享受以下权益：
        </p>
        <div style="color: #fff; line-height: 0.5rem">
          <p style="text-indent: 0.3rem">
            ①签到可免费领取精美乳胶枕一个。（每人限领一份，数量有限，先到先得）
          </p>
          <p style="text-indent: 0.3rem">
            ②签到可领取300元代金券。（2张100元建材代金券，1张100元家具代金券）
          </p>
          <p style="text-indent: 0.3rem">
            ③签到可领取新年福袋一个。（含：对联、红包、福字）
          </p>
          <p style="text-indent: 0.3rem">
            ④签到可领取超级品牌专属礼券一张（参与品牌可到升辉装饰城现场查看）
          </p>
        </div>
        <div style="color: red; text-align: center; padding: 0.1rem 0">
          （注：活动最终解释权归徐州市房地产信息网所有）
        </div>
      </div>
    </div>
    <img
      class="to_top"
      @click="toTop"
      src="@/assets/img/toTop.png"
      alt=""
      v-show="toTopShow"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      img1:require('@/assets/img/vote/1.png'),
      img2:require('@/assets/img/vote/2.png'),
      img3:require('@/assets/img/vote/3.png'),
      // img4:require('@/assets/img/vote/4.png'),
      textColor: "#fff",
      bgColor: "transparent",
      objData: {},
      appToken: "",
      toTopShow: false,
      isApp: this.$route.query.isApp || false,
      isWx: this.$route.query.isWx || false,
      wxAppToken: this.$route.query.user || false,
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      list8: [],
    };
  },
  inject: ["judgeApp"],
  created() {
    this.initData();
    this.$share(
      "守望来者·谋远前行 徐州市房地产信息网 2021中国·徐州房地产行业颁奖盛典",
      "行业盛典,等你投票",
      "https://www.xzhouse.com.cn/house/xzh_static/sVideo/vote.jpg"
    );
  },
  components: {},
  mounted() {
    // if (this.isApp) {
    //   window.sessionStorage.setItem("isApp", true);
    // }
    // if (this.isWx) {
    //   window.sessionStorage.setItem("isWx", true);
    // }
    // if (this.wxAppToken) {
    //   window.sessionStorage.setItem("wxAppToken", this.wxAppToken);
    // }
    // this.assignmentTooken();
    // window.addEventListener("scroll", this.handleScroll);
    window.onscroll = () => {
      this.handleScroll;
      var scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 400) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    };
  },
  methods: {
    returnGo() {
      if ((this.isApp && this.isApp != false) || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
    initData() {
      this.$http({
        url: "house/tpRecord/getListAllType.do",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        this.objData = res.obj;
      });
    },
    decShow() {
      console.log("wqwqw");
    },
    btnJump(num) {
      if (this.isApp || this.isApp == "true") {
        this.$router.push({
          path: "/voteList",
          query: { type: num, isApp: this.isApp },
        });
      } else {
        this.$router.push({
          path: "/voteList",
          query: { type: num },
        });
      }
    },
    toTop() {
      this.$refs.topBanner.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    jump(item) {
      let _this = this;
      this.$nextTick(() => {
        let company = _this.$el.querySelector(item);
        document.documentElement.scrollTop = company.offsetTop; //苹果滚动
        document.body.scrollTop = company.offsetTop; //安卓滚动
      });
    },
  },
};
</script>
 <style lang="less" scoped>
@media only screen and (min-width: 980px) {
  #vote {
    max-width: 1100px;
    margin: 0 auto;
    .fixed {
      display: none;
    }
    .titleBlock {
      .mian_img {
        img {
          // height: 6.5rem;
        }
      }
    }
    .modular {
      .v_width {
        width: 60%;
        margin: 0 auto;
      }
      .title {
        width: 55%;
      }
      .hd_word {
        font-size: 0.2rem;
      }
      .v_flex {
        .line {
          width: 23%;
          .btn {
            p {
              font-size: 0.2rem;
              padding: 0;
            }
          }
          .photo {
            img {
              height: 1.8rem;
            }
          }
          .name {
            padding: 0;
            font-size: 0.2rem;
          }
        }
      }
    }
  }
}

@keyframes changeImg {
  from {
    left: -10%;
  }
  100% {
    left: 100%;
  }
}
.vote {
  background: #121211;
  padding: 0.1rem;
  padding-top: 0.1px;
  .titleBlock {
    position: relative;
    .t_flex {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: space-around;
      & > div {
        flex: 0 1 22%;
        p {
          color: red;
          text-align: center;
        }
      }
    }
    .mian_img {
      width: 100%;
      img {
        width: 100%;
        vertical-align: bottom;
      }
    }
    .title1 {
      z-index: 1000;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      display: flex;
      justify-content: space-between;
      padding: 0 0.4rem;
      left: 0;
      width: 100%;
      & > p {
        letter-spacing: 2px;
        writing-mode: vertical-lr;
        padding: 0.2rem 0.1rem 0.2rem 0.1rem;
        text-align: center;
        font-size: 0.3rem;
        width: 0.5rem;
        color: #f2d892;
        border-bottom-right-radius: 0.4rem;
        border-bottom-left-radius: 0.4rem;
        background: rgba(204, 204, 204, 0.5);
      }
    }
  }
  .modular {
    padding: 0.1rem 0.2rem;
    position: relative;
    margin-top: 0.2rem;
    background: #121211;
    .h_flex {
      display: flex;
      justify-content: space-between;
      & > div {
        color: #f2d892;
        text-align: center;
        flex: 1;
        font-size: 0.25rem;
        .h_word {
          font-weight: 900;
          font-size: 0.2rem;
        }
      }
    }
    .v_title {
      font-size: 0.3rem;
      text-align: center;
      color: #f2d892;
    }
    // .t_word {
    //   text-indent: 2px;
    //   letter-spacing: 2px;
    //   padding: 0.6rem;
    //   font-size: 0.3rem;
    //   text-align: center;
    // }
    .title {
      // text-indent: 2px;
      // letter-spacing: 2px;
      // padding-bottom: 0.3rem;
      width: 90%;
      margin: 0 auto;
      // height:2rem;
      // padding: 0.1rem 0;
      // text-align: center;
      // border-radius: 0.1rem;
      // font-size: 0.4rem;
      // position: absolute;
      // top: -0.2rem;
      // left: 50%;
      // transform: translateX(-50%);
      // color: #fff;
      // font-weight: 900;
      // background: rgba(189, 93, 230, 0.6);
      & > img {
        width: 100%;
        // height:100%;
      }
    }
    .hd_word {
      padding: 0.2rem 0;
      font-size: 0.3rem;
      color: #f2d892;
      .hd_bj {
        display: flex;
        p:last-child {
          flex: 0 1 66%;
          color: #fff;
        }
        p:first-child {
          flex: 0 1 34%;
        }
      }
    }
    .v_flex {
      // padding-top: 0.2rem;
      display: flex;
      flex-wrap: wrap;
      margin-top:-0.3rem;
      // writing-mode: vertical-lr;
      justify-content: space-between;
      .line_expert {
        width: 30%;
      }
      .line {
        // writing-mode: horizontal-tb;
        width: 49%;
        position: relative;
        margin-top: 0.5rem;
        background: #ccc;
        padding: 0.2rem;
        box-sizing: border-box;
        .line_img{
          width: 0.7rem;
          height:1rem;
          position: absolute;
          top:0;
          left:0;
          img{
            width:100%;
            height:100%;
          }
        }
        .photo {
          width: 100%;
          img {
            height: 2.3rem;
            width: 100%;
          }
        }
        .name {
          padding: 0.1rem 0;
          text-align: center;
          color: #000;
          font-size: 0.3rem;
        }

        .btn {
          box-sizing: border-box;
          padding: 0.1rem 0.2rem;
          p {
            position: relative;
            text-indent: 3px;
            letter-spacing: 3px;
            background: #000;
            color: #fff;
            font-weight: 800;
            font-size: 0.3rem;
            text-align: center;
            padding: 0.1rem;
            border-radius: 5px;
            overflow: hidden;
            &::after {
              position: absolute;
              animation: changeImg 3s ease 0;
              top: 0;
              width: 30%;
              height: 100%;
              content: "";
              background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0,
                rgba(255, 255, 255, 0.4) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              transform: skewX(-30deg);
              animation-iteration-count: infinite;
            }
          }
        }
      }
    }
  }
}
.to_top {
  width: 0.84rem;
  height: 0.84rem;
  position: fixed;
  z-index: 2000;
  right: 0.15rem;
  bottom: 1.5rem;
}
.fixed {
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  width: 50%;
  z-index: 9909;
  background-color: transparent;
  .top_header {
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 100%;
    margin: 0 auto;
    .back_ {
      width: 0.38rem;
      height: 0.38rem;
    }
    .top_normal {
      align-items: center;
      display: flex;
      height: 100%;
    }
  }
}
</style>